import { render, staticRenderFns } from "./CanvasCourseMappingList.vue?vue&type=template&id=7c76dbe2"
import script from "./CanvasCourseMappingList.vue?vue&type=script&lang=ts"
export * from "./CanvasCourseMappingList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports